module.exports = __webpack_public_path__ + "img/電気回路_2_1_5.b2a8422e.png";